import { render, staticRenderFns } from "./LayoutWizardMetadataGroup.vue?vue&type=template&id=23a48ed3"
import script from "./LayoutWizardMetadataGroup.js?vue&type=script&lang=js&external"
export * from "./LayoutWizardMetadataGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports